<div class="input-main-form-wrapper">
  @if (label) {
    <label
      class="input-main-label"
      for="{{ controlName }}"
    >{{ label }}</label>
  }
  <form
    class="input-main-form"
    (ngSubmit)="submitForm()"
    [formGroup]="form"
  >
    @if (hasPrefix) {
      <ng-content />
    }
    <mat-form-field
      class="input-main"
      [ngClass]="[formFieldClass, hasPrefix ? sizeClass() : '']"
      appearance="outline"
    >
      <input
        id="{{ controlName }}"
        type="{{ formItemType }}"
        (blur)="onBlur()"
        (focus)="onFocus()"
        [formControlName]="controlName"
        [mask]="applyPhoneMask ? phoneMask || DEFAULT_COUNTRY.mask : null"
        [max]="max"
        [min]="min"
        [shownMaskExpression]="applyPhoneMask ? phoneMaskExpression || DEFAULT_COUNTRY.maskExpression : null"
        #input
        autocomplete="off"
        matInput
        placeholder="{{ placeholder }}"
      />
      @if (!form.controls[controlName].disabled && !form.controls[controlName].errors && !showSubmitButton) {
        <button
          class="bg-transparent text-xs text-ui-dark font-semibold px-2 mx-3 rounded-md border border-ui-gray-light leading-[22px]"
          matSuffix
        >
          Edit
        </button>
      }
      @if (form.controls[controlName].errors) {
        <mat-icon matSuffix>report</mat-icon>
      }
      <mat-error>Input is not valid</mat-error>
    </mat-form-field>
    @if (form.valid) {
      <button
        type="submit"
        class="text-white font-semibold bg-ui-green-light hover:bg-ui-green-350 active:bg-ui-green-light px-2 text-xs leading-6 rounded-md"
        [class.is-active]="showSubmitButton"
        #submitButton
        matSuffix
      >
        Save
      </button>
    }
  </form>
</div>
